var path = 'areas/projects/actions/Octopus.TentaclePackage_summary.html';
var html = "<p> Deploy package <strong>{{ packageId }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ feedId }}</em> <span ng-show=isSingleStep>to machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.TentaclePackage_summary.html
// module id = 3024674056194180
// module chunks = 1